import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { InputGroup, InputRightElement, SimpleGrid } from '@chakra-ui/react';

import { InvoicingDefaultLateMaxDaysTypeEnum } from '__generated__/GQL';
import * as Form from 'components/_core/form';
import IconButton from 'components/_core/IconButton';
import Text from 'components/_core/Text';
import { DEFAULT_LATE_MAX_DAYS_TYPE } from 'features/Work/constants';

import { InvoicePresetsFormSchema } from '../../invoicePresetsForm.schema';
import locales from './locales';

interface LateMaxDaysProps {
  control: Control<InvoicePresetsFormSchema>;
}

const DELAY_OPTIONS = [
  { label: locales.noDelay, value: InvoicingDefaultLateMaxDaysTypeEnum.Zero },
  {
    label: locales.formatString(locales.days, { count: 7 }),
    value: InvoicingDefaultLateMaxDaysTypeEnum.Seven,
  },
  {
    label: locales.formatString(locales.days, { count: 14 }),
    value: InvoicingDefaultLateMaxDaysTypeEnum.Fourteen,
  },
  {
    label: locales.formatString(locales.days, { count: 15 }),
    value: InvoicingDefaultLateMaxDaysTypeEnum.Fifteen,
  },
  {
    label: locales.formatString(locales.days, { count: 21 }),
    value: InvoicingDefaultLateMaxDaysTypeEnum.TwentyOne,
  },
  {
    label: locales.formatString(locales.days, { count: 30 }),
    value: InvoicingDefaultLateMaxDaysTypeEnum.Thirty,
  },
  {
    label: locales.fortyFiveEndOfMonth,
    value: InvoicingDefaultLateMaxDaysTypeEnum.FortyFiveEndOfMonth,
  },
  { label: locales.other, value: InvoicingDefaultLateMaxDaysTypeEnum.Other },
] satisfies { label: string; value: InvoicingDefaultLateMaxDaysTypeEnum }[];

const LateMaxDays: FC<LateMaxDaysProps> = ({ control }) => (
  <SimpleGrid columns={2} templateColumns="repeat(2, 50%)">
    <Text fontWeight="weight-500" paddingLeft="space-16" variant="primary">
      {locales.label}
    </Text>

    <Controller
      control={control}
      name="lateMaxDaysType"
      render={({ field: typeField }) =>
        typeField.value === InvoicingDefaultLateMaxDaysTypeEnum.Other ? (
          <Controller
            control={control}
            name="lateMaxDaysOther"
            render={({ field: otherField, formState: { errors } }) => (
              <Form.Field error={errors.lateMaxDaysOther?.message}>
                <InputGroup>
                  <Form.Input
                    // eslint-disable-next-line jsx-a11y/no-autofocus
                    autoFocus
                    onChange={(e) =>
                      otherField.onChange(
                        e.target.value === '' ? null : Number(e.target.value),
                      )
                    }
                    type="number"
                    value={otherField.value ?? undefined}
                  />

                  <InputRightElement paddingRight={0}>
                    <IconButton
                      aria-label=""
                      icon="cancel"
                      iconSize="icon-20"
                      onClick={() => {
                        otherField.onChange(null);
                        typeField.onChange(DEFAULT_LATE_MAX_DAYS_TYPE);
                      }}
                      size="sm"
                      variant="inline-secondary"
                    />
                  </InputRightElement>
                </InputGroup>
              </Form.Field>
            )}
          />
        ) : (
          <Form.SunshineSelect
            onChange={(option) => typeField.onChange(option?.value)}
            options={DELAY_OPTIONS}
            value={DELAY_OPTIONS.find(
              (option) => option.value === typeField.value,
            )}
          />
        )
      }
    />
  </SimpleGrid>
);

export default LateMaxDays;
